import { assertContractParameterType, common, IOHelper, JSONHelper, toJSONContractParameterType, } from '@neo-one/client-common';
import { assertContractPropertyState, ContractModel } from '@neo-one/client-full-common';
import { ContractPropertyState } from './ContractPropertyState';
import { BinaryReader, utils } from './utils';
export class Contract extends ContractModel {
    constructor() {
        super(...arguments);
        this.equals = utils.equals(Contract, this, (other) => common.uInt160Equal(this.hash, other.hash));
        this.toKeyString = utils.toKeyString(Contract, () => this.hashHex);
        this.contractSizeInternal = utils.lazy(() => sizeOfContract({
            script: this.script,
            parameterList: this.parameterList,
            name: this.name,
            codeVersion: this.codeVersion,
            author: this.author,
            email: this.email,
            description: this.description,
        }));
    }
    static deserializeWireBase(options) {
        return deserializeContractWireBase({
            context: options.context,
            reader: options.reader,
        });
    }
    static deserializeWire(options) {
        return this.deserializeWireBase({
            context: options.context,
            reader: new BinaryReader(options.buffer),
        });
    }
    get size() {
        return this.contractSizeInternal();
    }
    serializeJSON(_context) {
        return {
            version: this.version,
            hash: JSONHelper.writeUInt160(this.hash),
            script: JSONHelper.writeBuffer(this.script),
            parameters: this.parameterList.map(toJSONContractParameterType),
            returntype: toJSONContractParameterType(this.returnType),
            name: this.name,
            code_version: this.codeVersion,
            author: this.author,
            email: this.email,
            description: this.description,
            properties: {
                storage: this.hasStorage,
                dynamic_invoke: this.hasDynamicInvoke,
                payable: this.payable,
            },
        };
    }
}
export const sizeOfContract = ({ script, parameterList, name, codeVersion, author, email, description, publishVersion, }) => IOHelper.sizeOfVarBytesLE(script) +
    IOHelper.sizeOfVarBytesLE(Buffer.from(parameterList)) +
    IOHelper.sizeOfUInt8 +
    (publishVersion === undefined ? IOHelper.sizeOfBoolean : 0) +
    IOHelper.sizeOfVarString(name) +
    IOHelper.sizeOfVarString(codeVersion) +
    IOHelper.sizeOfVarString(author) +
    IOHelper.sizeOfVarString(email) +
    IOHelper.sizeOfVarString(description);
export const deserializeContractWireBase = ({ reader, publishVersion, }) => {
    const script = reader.readVarBytesLE();
    const parameterList = [...reader.readVarBytesLE()].map(assertContractParameterType);
    const returnType = assertContractParameterType(reader.readUInt8());
    const contractProperties = publishVersion === undefined || publishVersion >= 1
        ? assertContractPropertyState(reader.readUInt8())
        : ContractPropertyState.NoProperty;
    const name = reader.readVarString(252);
    const codeVersion = reader.readVarString(252);
    const author = reader.readVarString(252);
    const email = reader.readVarString(252);
    const description = reader.readVarString(65536);
    return new Contract({
        script,
        parameterList,
        returnType,
        contractProperties,
        name,
        codeVersion,
        author,
        email,
        description,
    });
};

//# sourceMappingURL=Contract.js.map
